__webpack_require__.p = "https://static.parastorage.com/services/ecom-platform-cart-icon/65bae07a89d5f94a8eea0ae1744ff30c1370e8e9fc92b7d97889772a/";